import { CONTENT_KEYWORD_FILTER_BY_STATE } from './constants';

// Strip CMS resource link tokens (`[text | type:slug=x]`) from a raw HTML string when the
// linked resource's standard keyword (CCSS / TEKS / FL BEST) shouldn't be shown to the
// user's state, then drop any list item left empty so filtered-out links don't leave empty
// bullets. Admins bypass filtering. Used for both lesson resources and library page headers.
const filterContentKeywordsHTML = (htmlString, userState, isAdmin) => {
  if (isAdmin || !htmlString) return htmlString;

  const stateFilter = CONTENT_KEYWORD_FILTER_BY_STATE.find(({ state }) => state.test(userState));
  if (!stateFilter) return htmlString;

  let result = htmlString;
  for (const keyword of stateFilter.keywords) {
    result = result.replace(new RegExp(`\\[[^\\]]*${keyword.source}[^\\]]*\\]`, 'g'), '');
  }
  // Remove list items emptied by token removal (only whitespace / &nbsp; remain).
  return result.replace(/<li[^>]*>(?:\s|&nbsp;)*<\/li>/g, '');
};

export default filterContentKeywordsHTML;
